import {
  faFileInvoiceDollar,
  faGaugeHigh,
  faPlus,
  faReceipt,
  faTableList,
  type IconDefinition
} from '@fortawesome/free-solid-svg-icons';

import {
  VIEW_BILLING_REPORT_PERMISSIONS,
  VIEW_BILLING_REPORT_RESULTS_PERMISSIONS
} from '@/pages/BillingReportResults/constants';
import { UserPermissions } from '@/types/user';
import { NavPermissionRule, passesPermissionRule } from '@/utils/navPermissionRule';
import type { MatchableNavItem } from '@/utils/resolveCurrentNavLabel';

export interface BillingNavDefinition extends MatchableNavItem {
  icon: IconDefinition;
  permissionRule?: NavPermissionRule;
}

/**
 * The billing section's pages. These were a row of buttons on the billing dashboard; the dashboard
 * still shows them below `lg`, where there is no rail to hold them.
 */
export const BILLING_NAV_DEFINITIONS: BillingNavDefinition[] = [
  // Only the dashboard itself, or `/billing/items` would never win against it.
  { label: 'Dashboard', path: '/billing/', exact: true, icon: faGaugeHigh },
  {
    label: 'Billing Items',
    path: '/billing/items',
    alsoMatches: ['/billing/claims'],
    icon: faTableList
  },
  {
    label: 'Billing Reports',
    path: '/billing/reports',
    icon: faFileInvoiceDollar,
    permissionRule: {
      type: 'all',
      requiredPermissions: [
        ...VIEW_BILLING_REPORT_RESULTS_PERMISSIONS,
        ...VIEW_BILLING_REPORT_PERMISSIONS
      ]
    }
  },
  // The edit routes live under /billing/remit/, so the list owns them too.
  { label: 'Remits', path: '/billing/remits', alsoMatches: ['/billing/remit'], icon: faReceipt },
  { label: 'Add a Remit', path: '/billing/remit/new', exact: true, icon: faPlus }
];

export const getAvailableBillingNavOptions = (
  permissions: UserPermissions | undefined
): BillingNavDefinition[] =>
  BILLING_NAV_DEFINITIONS.filter((option) =>
    passesPermissionRule(option.permissionRule, permissions)
  );
